import { render, staticRenderFns } from "./Diary5.vue?vue&type=template&id=0b793900&scoped=true"
import script from "./Diary5.vue?vue&type=script&lang=js"
export * from "./Diary5.vue?vue&type=script&lang=js"
import style0 from "./Diary5.vue?vue&type=style&index=0&id=0b793900&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b793900",
  null
  
)

export default component.exports